import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import {
  KeyHighlightsNumbers,
  KeyHighlightsText,
  KeyHighlightsHeader,
  StyledCeoQuote,
  StyledProfileDetails,
} from "../Typography"
import { Col, Container, Row, Visible } from "react-grid-system"
import { Fade } from "react-reveal"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"
import ClickHereToDownloadMobileRight from "../ClickHereToDownload/MobileRight"
import ClickHereToDownloadDesktop from "../ClickHereToDownload/Desktop"

const StyledSpecialCeoQuote = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.1em;
  /* line-height: 42px; */
  /* or 117% */

  color: #414042;

  margin-top: 31px;
  margin-bottom: 35px;

  ${breakpoint.xl} {
    padding-right: "40px";
  }
  ${breakpoint.xxl} {
    padding-right: "50px";
  }
`

const SectionWrapper = styled.section`
  margin-bottom: 15%;
  position: relative;
  z-index: 3;
  overflow-x: hidden;
`

const StyledClickToDownloadWrapper = styled.div`
  background-color: #0f6495;
  padding: 1.1em 1.1em;
  margin-bottom: 30px;
  /* margin-top: 6%; */
  margin-left: 18%;
  position: relative;
  z-index: 3;
`

const StyledGeographyLinesAbsoluteContainer = styled.div`
  position: absolute;
  z-index: 1;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  top: -5%;

  ${breakpoint.sm} {
    top: -9%;
  }

  ${breakpoint.sm} {
    top: -12%;
  }

  ${breakpoint.lg} {
    top: -15%;
  }
`

const StyledGeographyLinesWrapper = styled.div`
  position: relative;
  width: 80%;
  right: -55%;
  transform: rotate(30deg);

  ${breakpoint.lg} {
    width: 50%;
    right: -53%;
  }
  ${breakpoint.xl} {
    width: 45%;
    max-width: 750px;
    right: -60%;
  }
`

const CeoSection = () => {
  return (
    <>
      <Visible xs sm md>
        <SectionWrapper>
          <ClickHereToDownloadMobileRight />
          <Container>
            <Row>
              <Col xs={11} offset={{ xs: 1 }}></Col>
              <Col xs={12}>
                <Fade ssrReveal left duration={500}>
                  <div
                    style={{ width: "50%", position: "relative", zIndex: 3 }}
                  >
                    <StaticImage
                      src="../../images/david-heng.png"
                      alt="david heng"
                      quality={95}
                    />
                  </div>
                  <div
                    style={{ width: "100%", position: "relative", zIndex: 3 }}
                  >
                    <StyledCeoQuote
                      style={{
                        paddingRight: "20px",
                        marginTop: "31px",
                        marginBottom: "35px",
                      }}
                    >
                      "It gives me great pleasure to share the progress and
                      learnings from the first year of our impact investing
                      journey at ABC World Asia. We raised our inaugural S$405M
                      fund in 2019 and deployed about S$98M in 2020, adding five
                      companies to our portfolio. As we continue to evolve, we
                      hope to encourage more active dialogue and further
                      adoption of impact investing in Asia by sharing our
                      insights through our annual Impact Report.”
                    </StyledCeoQuote>
                  </div>
                  <div>
                    <StyledProfileDetails style={{ color: "#0F6497" }}>
                      David Heng
                    </StyledProfileDetails>
                    <StyledProfileDetails style={{ color: "#414042" }}>
                      CEO
                    </StyledProfileDetails>
                  </div>
                </Fade>
              </Col>
            </Row>
          </Container>
          <Fade ssrReveal right duration={500}>
            <div
              style={{
                backgroundColor: "#EBEBEC",
                padding: "1.1em 1.1em",
                marginLeft: "18%",
                marginTop: "50px",
              }}
            >
              <div style={{ marginBottom: "15px" }}>
                <KeyHighlightsHeader as="h3">
                  Key Highlights
                </KeyHighlightsHeader>
              </div>
              <div style={{ marginBottom: "20px" }}>
                <KeyHighlightsNumbers>S$405M</KeyHighlightsNumbers>
                <KeyHighlightsText>Capital Raised</KeyHighlightsText>
              </div>
              <KeyHighlightsNumbers>S$98M</KeyHighlightsNumbers>
              <KeyHighlightsText>Invested in 2020</KeyHighlightsText>
            </div>
          </Fade>
          <Visible xs sm md>
            <StyledGeographyLinesAbsoluteContainer>
              <StyledGeographyLinesWrapper>
                <Fade ssrReveal delay={400}>
                  <StaticImage
                    src="../../images/geography-lines-1.png"
                    alt="geography lines"
                    layout="fullWidth"
                  />
                </Fade>
              </StyledGeographyLinesWrapper>
            </StyledGeographyLinesAbsoluteContainer>
          </Visible>
        </SectionWrapper>
      </Visible>

      <Visible lg xl xxl>
        <section
          style={{
            marginBottom: "220px",
            position: "relative",
            zIndex: 3,
            overflowX: "hidden",
          }}
        >
          <Container>
            <Row>
              <Col lg={6}>
                <Fade ssrReveal left duration={500}>
                  <div style={{ width: "40%" }}>
                    <StaticImage
                      src="../../images/david-heng.png"
                      alt="david heng"
                      quality={95}
                    />
                  </div>
                  <div style={{ width: "100$" }}>
                    <StyledSpecialCeoQuote>
                      "It gives me great pleasure to share the progress and
                      learnings from the first year of our impact investing
                      journey at ABC World Asia. We raised our inaugural S$405M
                      fund in 2019 and deployed about S$98M in 2020, adding five
                      companies to our portfolio. As we continue to evolve, we
                      hope to encourage more active dialogue and further
                      adoption of impact investing in Asia by sharing our
                      insights through our annual Impact Report.”
                    </StyledSpecialCeoQuote>
                  </div>
                  <div>
                    <StyledProfileDetails style={{ color: "#0F6497" }}>
                      David Heng
                    </StyledProfileDetails>
                    <StyledProfileDetails style={{ color: "#414042" }}>
                      CEO
                    </StyledProfileDetails>
                  </div>
                </Fade>
              </Col>
              <Col lg={6} xl={5} offset={{ xl: 1 }}>
                <Fade ssrReveal right duration={500} delay={400}>
                  <ClickHereToDownloadDesktop />
                  <div
                    style={{
                      backgroundColor: "#EBEBEC",
                      paddingTop: "2em",
                      paddingBottom: "2em",
                      paddingLeft: "2em",
                      paddingRight: "15px",
                    }}
                  >
                    <div style={{ marginBottom: "30px" }}>
                      <KeyHighlightsHeader as="h3">
                        Key Highlights
                      </KeyHighlightsHeader>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                      <KeyHighlightsNumbers>S$405M</KeyHighlightsNumbers>
                      <KeyHighlightsText>Capital Raised</KeyHighlightsText>
                    </div>
                    <KeyHighlightsNumbers>S$98M</KeyHighlightsNumbers>
                    <KeyHighlightsText>Invested in 2020</KeyHighlightsText>
                  </div>
                </Fade>
              </Col>
            </Row>
          </Container>
        </section>
      </Visible>
    </>
  )
}

export default CeoSection
